import React, { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
}

const TextField: FC<Props> = ({ title }) => {
  return (
    <Box width="full" gap="s24" flexDirection="row">
      <Box width="full" gap="s4">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {title}
        </Text.Normal>
        <Box
          background="grey000White"
          padding="s16"
          borderRadius={{ all: 'abs008' }}
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
        >
          <Box padding="s4"></Box>
        </Box>
      </Box>
    </Box>
  )
}

export default TextField
